jQuery(document).ready(function( $ ){
  $(document).ready(function(){
      $('.inner').slick({
        infinite: true,
        dots:false,
        arrows:false,
        slidesToShow: 1,
        slidesToScroll: 1,
        Transform: false
      });

     
/*    
  	$('ul.tabs li').click(function(){
  		var tab_id = $(this).attr('data-tab');
  		$('ul.tabs li').removeClass('current');
  		$('.tab-content').removeClass('current');
  		$(this).addClass('current');
  		$("#"+tab_id).addClass('current');
  	});
    */

    $(".layer-trigger").click(function(){
       $(".layer-trigger").removeClass("active");
       $(this).addClass("active");
  
       //var slideno = $(this).data('slide');
       //$('.inner').slick('slickGoTo', slideno - 1);
       
    });
  
      $('g[data-slide]').click(function(e) {
         e.preventDefault();
         var slideno = $(this).data('slide');
         $('.inner').slick('slickGoTo', slideno - 1);
      });
      
      
  });

  

});